// ======================FAQ's Icons==========================================
import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/react/24/outline";

import { motion, AnimatePresence } from "framer-motion";

const Accordion = ({ question, answer, isOpen, onClick }) => {
  return (
    <>
      <button
        onClick={onClick}
        className={`flex w-full items-center gap-3 bg-white px-6 py-2 font-light`}
      >
        <motion.div
          initial={false}
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          {isOpen ? (
            <MinusCircleIcon className="h-8 w-8 font-thin text-visRed" />
          ) : (
            <PlusCircleIcon className="h-8 w-8 font-thin text-visRed" />
          )}
        </motion.div>
        <p className="text-start font-normal">{question}</p>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.p
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.3, ease: "linear" }}
            className="overflow-hidden bg-white pl-[4.25rem] pr-4"
          >
            <p className="py-2">{answer}</p>
          </motion.p>
        )}
      </AnimatePresence>
    </>
  );
};

export default Accordion;
